import {
  DEFAULT_DEFECT_RECT_H,
  DEFAULT_DEFECT_RECT_W,
  DEFECT_DRAWER_VIEW_H,
  DEFECT_DRAWER_VIEW_W
} from '@/utils/defect/defaultDefectDrawerRect';

function positiveSize(value, fallback) {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : fallback;
}

/**
 * covering 신규 결함: 모듈 전체를 감싸지 않고, 작은 기본 박스를 모듈 중심에 둔다.
 */
export function resolveCoveringNewDefectRect({
  moduleNx,
  moduleNy,
  imageWidth = DEFECT_DRAWER_VIEW_W,
  imageHeight = DEFECT_DRAWER_VIEW_H,
  width = DEFAULT_DEFECT_RECT_W,
  height = DEFAULT_DEFECT_RECT_H
} = {}) {
  const w = positiveSize(width, DEFAULT_DEFECT_RECT_W);
  const h = positiveSize(height, DEFAULT_DEFECT_RECT_H);
  const imgW = positiveSize(imageWidth, DEFECT_DRAWER_VIEW_W);
  const imgH = positiveSize(imageHeight, DEFECT_DRAWER_VIEW_H);

  const cx =
    Number.isFinite(moduleNx) && Number.isFinite(moduleNy) ? moduleNx * imgW : imgW / 2;
  const cy =
    Number.isFinite(moduleNx) && Number.isFinite(moduleNy) ? moduleNy * imgH : imgH / 2;

  const maxX = Math.max(0, imgW - w);
  const maxY = Math.max(0, imgH - h);
  const x = Math.min(Math.max(0, Math.round(cx - w / 2)), maxX);
  const y = Math.min(Math.max(0, Math.round(cy - h / 2)), maxY);

  return { x, y, rect_w: w, rect_h: h };
}
